import React, { useId } from 'react'
import PropTypes from 'prop-types'

const AppleLogoIcon = React.forwardRef(function AppleLogoIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M18.3112 12.76C18.2812 9.72997 20.7912 8.24997 20.9112 8.17997 19.4912 6.10997 17.2912 5.81997 16.5112 5.79997 14.6612 5.60997 12.8712 6.90997 11.9212 6.90997 10.9712 6.90997 9.51116 5.81997 7.94116 5.84997 5.93116 5.87997 4.04116 7.04997 3.01116 8.85997.881162 12.55 2.47116 17.97 4.51116 20.96 5.53116 22.42 6.73116 24.05 8.29116 23.99 9.82116 23.93 10.3912 23.02 12.2312 23.02 14.0712 23.02 14.5912 23.99 16.1912 23.96 17.8312 23.93 18.8612 22.49 19.8512 21.02 21.0312 19.35 21.5012 17.7 21.5212 17.61 21.4812 17.6 18.3312 16.4 18.3012 12.76H18.3112ZM15.3012 3.85C16.1212 2.82 16.6812 1.42 16.5312 0 15.3412.05 13.8512.82 12.9912 1.83 12.2312 2.72 11.5512 4.17 11.7312 5.53 13.0712 5.63 14.4412 4.86 15.3012 3.84V3.85Z"></path>
    </svg>
  )
})

AppleLogoIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

AppleLogoIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default AppleLogoIcon
